// import React, { useState } from "react";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionHeader,
//   AccordionBody,
// } from "reactstrap";
// import redLeftArrow from "../../assets/icons/redLeftArrow.svg";

// const RenderModuleRecursive = ({ module, permission, handleMainCheckBox }) => {
//   const [open, setOpen] = useState(null); // control this level only

//   const hasChildren = module?.childmodules?.length > 0;
//   const hasSubmodules = module?.submodule?.length > 0;

//   const isChecked = (id) => permission?.some((p) => p?.id === id);

//   const toggle = (id) => setOpen(open === id ? null : id);

//   return (
//     <Accordion open={open} toggle={toggle}>
//       <AccordionItem key={module?.id}>
//         <AccordionHeader targetId={String(module?.id)}>
//           <table className="ever-rise-role-table pb-2">
//             <tbody>
//               <tr>
//                 <td className="w-50 pb-3">
//                   <input
//                     type="checkbox"
//                     className="ever-rise-checkbox"
//                     name={module?.name}
//                     checked={isChecked(module?.id)}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleMainCheckBox(module);
//                     }}
//                   />
//                   <h6 className="d-inline ps-2 edittheamtitle">
//                     {module?.name}
//                     {(hasChildren || hasSubmodules) && (
//                       <img
//                         src={redLeftArrow}
//                         className="expand-arrow"
//                         alt="Expand"
//                       />
//                     )}
//                   </h6>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </AccordionHeader>

//         <AccordionBody accordionId={String(module?.id)}>
//           <div className="ever-rise-table">
//             <table className="ever-rise-role-table">
//               <tbody>
//                 {/* Unique Submodules not duplicated in childmodules */}
//                 {hasSubmodules &&
//                   [...new Map(module.submodule.map((item) => [item.id, item])).values()]
//                     .filter((sub) => !module.childmodules?.some((child) => child.id === sub.id))
//                     .map((sub) => (
//                       <tr key={sub?.id}>
//                         <td className="w-50">{sub?.name}</td>
//                         <td className="wdt-10">
//                           <input
//                             type="checkbox"
//                             className="ever-rise-checkbox"
//                             checked={isChecked(sub?.id)}
//                             name={sub?.name}
//                             onClick={() => handleMainCheckBox(sub)}
//                           />
//                         </td>
//                       </tr>
//                     ))}

//                 {/* Render child modules recursively */}
//                 {hasChildren &&
//                   module.childmodules.map((child) => (
//                     <tr key={child?.id}>
//                       <td className="w-50">
//                         <li>{child?.name}</li>
//                       </td>

//                       {child?.submodule?.length > 0 ? (
//                         <>
//                           {child.submodule.map((sub) => (
//                             <td key={sub?.id} className="wdt-10">
//                               <input
//                                 type="checkbox"
//                                 className="ever-rise-checkbox"
//                                 checked={isChecked(sub?.id)}
//                                 name={sub?.name}
//                                 onClick={() => handleMainCheckBox(sub)}
//                               />
//                             </td>
//                           ))}
//                           <td className="wdt-10">
//                             <input
//                               type="checkbox"
//                               className="ever-rise-checkbox"
//                               checked={child.submodule.every((sub) =>
//                                 isChecked(sub?.id)
//                               )}
//                               name={child?.name}
//                               onClick={() => handleMainCheckBox(child)}
//                             />
//                           </td>
//                         </>
//                       ) : child?.childmodules?.length > 0 ? (
//                         <td colSpan={5}>
//                           <RenderModuleRecursive
//                             module={child}
//                             permission={permission}
//                             handleMainCheckBox={handleMainCheckBox}
//                           />
//                         </td>
//                       ) : (
//                         <>
//                           <td className="wdt-10"></td>
//                           <td className="wdt-10">
//                             <input
//                               type="checkbox"
//                               className="ever-rise-checkbox"
//                               checked={isChecked(child?.id)}
//                               name={child?.name}
//                               onClick={() => handleMainCheckBox(child)}
//                             />
//                           </td>
//                         </>
//                       )}
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </div>
//         </AccordionBody>
//       </AccordionItem>
//     </Accordion>
//   );
// };

// export default RenderModuleRecursive;
import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";
import redLeftArrow from "../../assets/icons/redLeftArrow.svg";

const RenderModuleRecursive = ({ module, permission, handleMainCheckBox }) => {
  const [open, setOpen] = useState(null);

  const hasChildren = module?.childmodules?.length > 0;
  const hasSubmodules = module?.submodule?.length > 0;

  const isChecked = (id) => permission?.some((p) => p?.id === id);

  const toggle = (id) => setOpen(open === id ? null : id);

  return (
    <Accordion open={open} toggle={toggle}>
      <AccordionItem key={module?.id}>
        <AccordionHeader targetId={String(module?.id)}>
          <table className="ever-rise-role-table pb-2">
            <tbody>
              <tr>
                <td className="w-50 pb-3">
                  <input
                    type="checkbox"
                    className="ever-rise-checkbox"
                    name={module?.name}
                    checked={isChecked(module?.id)}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMainCheckBox(module);
                    }}
                  />
                  <h6 className="d-inline ps-2 edittheamtitle">
                    {module?.name}
                    {(hasChildren || hasSubmodules) && (
                      <img
                        src={redLeftArrow}
                        className="expand-arrow"
                        alt="Expand"
                      />
                    )}
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
        </AccordionHeader>

        <AccordionBody accordionId={String(module?.id)}>
          <div className="ever-rise-table">
            <table className="ever-rise-role-table">
              <tbody>
                {/* Unique Submodules not duplicated in childmodules */}
                {hasSubmodules &&
                  [...new Map(module.submodule.map((item) => [item.id, item])).values()]
                    .filter((sub) => !module.childmodules?.some((child) => child.id === sub.id))
                    .map((sub) => (
                      <tr key={sub?.id}>
                        <td className="w-50">{sub?.name}</td>
                        <td className="wdt-10">
                          <input
                            type="checkbox"
                            className="ever-rise-checkbox"
                            checked={isChecked(sub?.id)}
                            name={sub?.name}
                            onClick={() => handleMainCheckBox(sub)}
                          />
                        </td>
                      </tr>
                    ))}

                {/* Render child modules */}
                {hasChildren &&
                  module.childmodules.map((child) => (
                    <React.Fragment key={child?.id}>
                      <tr>
                        <td className="w-50">
                            <li>{child?.name}</li>
                        </td>

                        {child?.submodule?.length > 0 ? (
                          <>
                            {child.submodule.map((sub) => (
                              <td key={sub?.id} className="wdt-10">
                                <input
                                  type="checkbox"
                                  className="ever-rise-checkbox"
                                  checked={isChecked(sub?.id)}
                                  name={sub?.name}
                                  onClick={() => handleMainCheckBox(sub)}
                                />
                              </td>
                            ))}
                            <td className="wdt-10">
                              <input
                                type="checkbox"
                                className="ever-rise-checkbox"
                                checked={child.submodule.every((sub) =>
                                  isChecked(sub?.id)
                                )}
                                name={child?.name}
                                onClick={() => handleMainCheckBox(child)}
                              />
                            </td>
                          </>
                        ) : child?.childmodules?.length > 0 ? (
                          // FIXED: Only use empty cells for the permission columns
                          <>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                          </>
                        ) : (
                          <>
                            <td className="wdt-10"></td>
                            <td className="wdt-10">
                              <input
                                type="checkbox"
                                className="ever-rise-checkbox"
                                checked={isChecked(child?.id)}
                                name={child?.name}
                                onClick={() => handleMainCheckBox(child)}
                              />
                            </td>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                            <td className="wdt-10"></td>
                          </>
                        )}
                      </tr>
                      
                      {/* FIXED: Add separate row for child modules with their own children */}
                      {child?.childmodules?.length > 0 && (
                        <tr key={`nested-${child?.id}`}>
                          <td colSpan={6} className="p-0">
                            <RenderModuleRecursive
                              module={child}
                              permission={permission}
                              handleMainCheckBox={handleMainCheckBox}
                            />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};

export default RenderModuleRecursive;